import { LocationOn } from "@mui/icons-material";
import { Dialog, DialogContent, Typography, Button, Box } from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

export default function LocationNeededModal(props) {
  const { open, onClose, onRetry, onEnterPostal, checkProfile, locationOnProfile, navigateToProfile } = props;

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.LocationNeededModal || {};
  const {
    TEXT_LOCATION_NEEDED = English.LocationNeededModal?.TEXT_LOCATION_NEEDED,
    TEXT_WE_COULDNT_DETERMINE_LOCATION = English.LocationNeededModal
      .TEXT_WE_COULDNT_DETERMINE_LOCATION,
    BUTTON_TRY_LOCATION_AGAIN = English.LocationNeededModal.BUTTON_TRY_LOCATION_AGAIN,
    BUTTON_ENTER_POSTAL_CODE_MANUALLY = English.LocationNeededModal
      .BUTTON_ENTER_POSTAL_CODE_MANUALLY,
    BUTTON_USE_PROFILE_LOCATION = English.LocationNeededModal.BUTTON_USE_PROFILE_LOCATION,
    BUTTON_NO_LOCATION_ON_PROFILE = English.LocationNeededModal.BUTTON_NO_LOCATION_ON_PROFILE,
    TEXT_YOUR_EXACT_LOCATION_IS_NEVER_SHARED = English.LocationNeededModal
      .TEXT_YOUR_EXACT_LOCATION_IS_NEVER_SHARED
  } = LanguageData || {};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2
        }
      }}>
      <DialogContent sx={{ textAlign: "center" }}>
        {/* Location Icon */}
        <Box sx={{ fontSize: 40, color: BIBlue }}>
          <LocationOn fontSize="150px" />
        </Box>

        {/* Title */}
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          {TEXT_LOCATION_NEEDED}
        </Typography>

        {/* Description */}
        <Typography variant="body2"  sx={{color: "text.secondary",  mb: 3 }}>
          {TEXT_WE_COULDNT_DETERMINE_LOCATION}
        </Typography>

        {/* Buttons */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            variant="contained"
            fullWidth
            onClick={onRetry}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              py: 1.2
            }}>
            {BUTTON_TRY_LOCATION_AGAIN}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            onClick={onEnterPostal}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              py: 1.2
            }}>
            {BUTTON_ENTER_POSTAL_CODE_MANUALLY}
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => {
              if (locationOnProfile) {
                checkProfile();
              } else {
                navigateToProfile()
              }
            }}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              py: 1.2
            }}>
            {locationOnProfile ? BUTTON_USE_PROFILE_LOCATION : BUTTON_NO_LOCATION_ON_PROFILE}
          </Button>
        </Box>

        {/* Footer Note */}
        <Typography variant="caption"  sx={{color: "text.secondary",  mt: 3, display: "block" }}>
          {TEXT_YOUR_EXACT_LOCATION_IS_NEVER_SHARED}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
